import { render, staticRenderFns } from "./OriginElectricityFilter.vue?vue&type=template&id=5bc08940&"
import script from "./OriginElectricityFilter.vue?vue&type=script&lang=js&"
export * from "./OriginElectricityFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports